import React from 'react';
import { Box, Skeleton } from '@mui/material';

function WebsitesSekeleton() {
    return (
        <Box>
            <Box className="flex-row">
                <Box className="pr-12px">
                    <Skeleton height={40} variant="circular" width={40} />
                </Box>
                <Box>
                    <Skeleton height={20} variant="text" width={70} />
                    <Skeleton height={20} variant="text" width={150} />
                </Box>
            </Box>
            <Skeleton variant="text" />
        </Box>
    );
}

export default WebsitesSekeleton;
